<div class="flex flex-col w-full items-center">
  @let holdsLoaded = holdSelectors.loaded | select:false;
  @let hasPatron = patronSelectors.hasPatron | select:false;
  @let hasBlocks = patronStatusSelectors.hasBlocks | select:false;
  @let singleHold = holdSelectors.singleHold(catalogRecord) | select:FALLBACK_HOLD;
  @let availability = selectors.availabilityFor(catalogRecord) | select:FALLBACK_CATALOG_RECORD_AVAILABILITY;

  @if (holdSelectors.hasOneHold(catalogRecord) | select:false) {
    @let isEditable = holdStatelessSelectors.isEditable(singleHold) | select;
    @let cannotEditHoldTooltip = holdStatelessSelectors.cannotEditHoldTooltip(singleHold) | select:'';
    @let circulatingCopies = availabilitySelectors.recordCirculatingCopiesFor(availability) | select:0;

    <mx-outlined-button label="Edit Hold" [enabled]="!!isEditable" [disabledTooltip]="cannotEditHoldTooltip"
                        (click)="onEditHold(singleHold, circulatingCopies)" [class]="holdButtonSizeClass"/>

    <px-hold-position [status]="holdStatelessSelectors.statusFor(singleHold) | select:'REQUESTED'"
                      [queueIndex]="holdStatelessSelectors.queueIndexAsStringFor(singleHold) | select:''"
                      [copiesCount]="circulatingCopies"/>
  } @else if (holdSelectors.hasHolds(catalogRecord) | select:false) {
    <mx-filled-button label="View Holds" routeName="HOLDS" [class]="holdButtonSizeClass"/>

    <ng-container *ngTemplateOutlet="circulationHolds; context: { availability: availability }"/>
  } @else {
    <!-- Careful!  This button needs a calculated disabledTooltip since we display it for something more specific than the enablement calculation. -->
    <mx-filled-button label="Place Hold" [enabled]="!hasBlocks && (!hasPatron || holdsLoaded)"
                      [disabledTooltip]="hasBlocks ? 'Cannot place hold due to blocks on your account.' : ''"
                      (click)="onPlaceHold()" [class]="holdButtonSizeClass"/>

    <ng-container *ngTemplateOutlet="circulationHolds; context: { availability: availability }"/>
  }

  <ng-template #circulationHolds let-availability="availability">
    @let holdsCount = availabilitySelectors.recordHoldsInQueueFor(availability) | select:0;
    @let circulatingCopies = availabilitySelectors.recordCirculatingCopiesFor(availability) | select:0;

    <div>
      {{ holdsCount }} {{ holdsCount === 1 ? 'hold' : 'holds' }} on {{ circulatingCopies }} {{ circulatingCopies === 1 ? 'copy' : 'copies' }}
    </div>
  </ng-template>
</div>
